import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { BookCover } from './components/BookCover';
import { BookSidebar, TocItem } from './components/BookSidebar';
import { BookContent } from './pages/BookContent';
import { Footer } from './components/Footer';
const TOC_ITEMS: TocItem[] = [{
  id: 'legal',
  title: 'Aviso Legal'
}, {
  id: 'personal-note',
  title: 'Una Nota Personal',
  subtitle: 'Por qué este protocolo es diferente'
}, {
  id: 'introduction',
  title: 'Introducción',
  subtitle: 'El primer paso sin dolor'
}, {
  id: 'chapter-1',
  title: 'Capítulo 1',
  subtitle: 'El "Fuego" Invisible'
}, {
  id: 'chapter-2',
  title: 'Capítulo 2',
  subtitle: 'Los 7 Superalimentos "Escudo"'
}, {
  id: 'chapter-3',
  title: 'Capítulo 3',
  subtitle: 'Recetario de 15 Minutos'
}, {
  id: 'chapter-4',
  title: 'Capítulo 4',
  subtitle: 'Postres y Bebidas'
}, {
  id: 'back-matter',
  title: 'Recursos Finales',
  subtitle: 'FAQ y Lista de Compras'
}, {
  id: 'pricing',
  title: '💰 Precio y Acceso',
  subtitle: 'Obtén tu protocolo'
}];
export function App() {
  const [showCover, setShowCover] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('personal-note');
  const handleNavigate = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setSidebarOpen(false);
    }
  };
  if (showCover) {
    return <BookCover onStartReading={() => setShowCover(false)} data-id="element-0" />;
  }
  return <div className="flex min-h-screen bg-cream" data-id="element-1">
      <BookSidebar items={TOC_ITEMS} activeId={activeSection} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} onNavigate={handleNavigate} data-id="element-2" />

      <main className="flex-1 lg:pl-80 relative" data-id="element-3">
        {/* Mobile Header */}
        <div className="sticky top-0 z-30 flex items-center justify-between border-b border-sage/20 bg-cream/90 px-6 py-4 backdrop-blur-md lg:hidden" data-id="element-4">
          <span className="font-sans font-semibold text-forest truncate pr-4" data-id="element-5">
            Protocolo Anti-Inflamatorio 65+
          </span>
          <button onClick={() => setSidebarOpen(true)} className="rounded-full p-2 text-forest hover:bg-sage/10" data-id="element-6">
            <Menu className="h-6 w-6" data-id="element-7" />
          </button>
        </div>

        <BookContent onSectionChange={setActiveSection} data-id="element-8" />
        <Footer data-id="element-9" />
      </main>
    </div>;
}